<template>
    <div class="m-dev-manage">
        <h4 class="title">
            开发管理
            <el-popover :offset="192" popper-class="title-tips" width="447" trigger="hover">
                <div class="content">
                    <h5 class="sub-title">开发版本</h5>
                    <p>1.使用代码发布工具，将代码上传到开发版本中</p>
                    <p>2.开发版本只保留每人最新上传的一份代码，点击提交审核，可将代码提交审核</p>
                    <p>3.开发版本可删除，不影响线上版本和审核版本中的代码，重新发布代码，会将开发版本覆盖</p>
                    <h5 class="sub-title">审核版本</h5>
                    <p>1.只能有一份代码处于审核中，审核通过可以发布到线上，也可以被新版本覆盖重新提交审核</p>
                    <p>2.审核驳回不可再提交审核审核，只能被覆盖或删除</p>
                    <h5 class="sub-title">线上版本</h5>
                    <p>线上所有用户使用的代码版本，该版本代码在新版本代码发布后被覆盖更新</p>
                </div>
                <i slot="reference" class="icon-detail"></i>
            </el-popover>
        </h4>
        <el-row type="flex" class="content">
            <el-col class="item">
                <el-row class="title-ver" type="flex" justify="center" align="middle">
                    <span class="split"></span>
                    <span>开发版本</span>
                    <span class="split"></span>
                </el-row>
                <div v-if="development">
                    <div class="detail dev">
                        <div><label>版本号</label><span class="highlight">{{development.version}}</span></div>
                        <div><label>发布者</label><span>{{development.nickName}}</span></div>
                        <div><label>上传时间</label><span>{{formatDate(development.ctime)}}</span></div>
                        <div><label>描述</label><span>{{development.description}}</span></div>
                        <div>
                            <label>扫码体验</label>
                            <div class="code">
                                <img :src="codeUrl" class="qrcode" width="200">
                                <!-- <img :src="codeUrl" class="qrcode-big" width="120"> -->
                            </div>
                        </div>
                    </div>
                    <div class="op-btns" v-if="isSelf">
                        <btn :type="1" info="删除" :width="88" @click="openConfirm('Devdel')"></btn>
                        <btn :type="gray && gray.status !== 72 ? 3 : 0" :width="88" info="提交审核" @click="submitDevJudge()"></btn>
                        <btn :type="1" :info="codeType === 0?'新框架二维码':'原框架二维码'" :width="99" @click="getNewQrcode"></btn>
                    </div>
                </div>
                <div class="empty" v-else>暂无开发版本</div>
            </el-col>
            <el-col class="item">
                <el-row class="title-ver" type="flex" justify="center" align="middle">
                    <span class="split"></span>
                    <span>审核版本</span>
                    <span v-if="check" :class="{'status': true,'toAudit': check.status === 1, 'success': check.status === 3, 'fail': check.status === 2}">【{{statusMap[check.status]}}】</span>
                    <span class="split"></span>
                </el-row>
                <div v-if="check">
                    <div class="detail audit">
                        <div class="reject-info" v-if="check.status == 2">原因：{{check.rejectReason}}</div>
                        <div><label>版本号</label><span class="highlight">{{check.version}}</span></div>
                        <div><label>发布渠道</label><span>{{check.channelInfo}}</span></div>
                        <div><label>发布者</label><span>{{check.nickName}}</span></div>
                        <div><label>提交时间</label><span>{{formatDate(check.submitTime)}}</span></div>
                        <div><label>描述</label><span class="desc">{{check.description}}</span></div>
                    </div>
                    <div class="op-btns" v-if="!(allChannelData && allChannelData.product)">
                        <btn :type="1" info="详情" :width="88" @click="showDetailDialog('check')"></btn>
                        <btn :type="1" info="删除" :width="88" v-if="check.status === 2 && isSelf" @click="deleteAuditReject"></btn>
                        <!-- 无线上版本，首次发布，可直接发布 -->
                        <btn :type="gray && gray.status !== 72 ? 3 : 0" :width="88" info="提交发布" @click="submitPublish" v-if="check.status === 3 && isSelf"></btn>
                        <!-- 非首次发布 -->
                    </div>
                    <div class="op-btns" v-else>
                        <btn :type="1" info="详情" :width="88" @click="showDetailDialog('check')"></btn>
                        <btn :type="0" :width="88" info="灰度发布" @click="openConfirm('GrayPub')" v-if="check.status === 3 && isSelf"></btn>
                        <btn :type="0" :width="88" info="全量发布" @click="openConfirm('FullPub')" v-if="check.status === 3 && isSelf"></btn>
                    </div>
                </div>
                <div class="empty" v-else>暂无审核版本</div>
            </el-col>
            <el-col class="item" v-if="gray">
                <el-row class="title-ver" type="flex" justify="center" align="middle">
                    <span class="split"></span>
                    <span>灰度版本</span>
                    <span class="status success">【{{gray.status === 72 ? '已停止' : '灰度中'}}】</span>
                    <span class="split"></span>
                </el-row>
                <div>
                    <div class="detail">
                        <div><label>版本号</label><span class="highlight">{{gray.version}}</span></div>
                        <div><label>发布渠道</label><span>{{gray.channelInfo}}</span></div>
                        <div><label>发布者</label><span>{{gray.nickName}}</span></div>
                        <div><label>发布时间</label><span>{{formatDate(gray.grayPublishTime)}}</span></div>
                        <div><label>描述</label><span class="desc">{{gray.description}}</span></div>
                        <div v-if="gray.status !== 72"><label>灰度比例</label><span>{{gray.grayScale * 100}}%</span></div>
                        <div v-if="gray.status !== 72"><label>上线灰度策略</label><span>0-1小时 10%，1-2小时 20%，2-3小时 50%，3小时以后 全量</span></div>
                        <div class="reject-info" v-if="gray.status === 74">全量发布申请被驳回：{{gray.rejectReason}}</div>
                    </div>
                    <div class="op-btns" v-if="gray.status !== 72">
                        <btn :type="1" :width="88" info="详情" @click="showDetailDialog('gray')"></btn>
                        <btn :type="0" :width="88" info="停止灰度" @click="openConfirm('GrayStop')" v-if="gray.status !== 73 && isSelf"></btn>
                        <btn :type="0" :width="88" info="立即发布" @click="openConfirm('GrayToProduct')" v-if="gray.status !== 73 && isSelf"></btn>
                        <!-- <btn :type="0" :width="102" info="申请全量发布" @click="openConfirm('GrayCheckSubmit')" v-if="gray.status !== 73 &&isSelf"></btn>
                        <btn :type="0" :width="160" info="撤销全量发布审核申请" @click="openConfirm('GrayCheckRecall')" v-if="gray.status === 73 && isSelf"></btn> -->
                    </div>
                </div>
            </el-col>
            <el-col class="item" v-if="timerProduct">
                <el-row class="title-ver" type="flex" justify="center" align="middle">
                    <span class="split"></span>
                    <span>定时发布版本</span>
                    <span :class="{'status': true, 'success': timerProduct.status == 81, 'fail': timerProduct.status == 83}">【{{statusMap.time[timerProduct.status]}}】</span>
                    <span class="split"></span>
                </el-row>
                <div>
                    <div class="detail">
                        <div><label>版本号</label><span class="highlight">{{timerProduct.version}}</span></div>
                        <div><label>发布渠道</label><span>{{timerProduct.channelInfo}}</span></div>
                        <div><label>发布者</label><span>{{timerProduct.nickName}}</span></div>
                        <div><label>提交时间</label><span>{{formatDate(timerProduct.scheduleOptTime)}}</span></div>
                        <div><label>描述</label><span class="desc">{{timerProduct.description}}</span></div>
                        <div><label>定时发布时间</label><span :class="{'highlight': timerProduct.status == 81}">{{formatDate(timerProduct.schedulePublishTime)}}</span></div>
                    </div>
                    <div class="op-btns" v-if="timerProduct.status == 81">
                        <btn :type="1" :width="88" info="详情" @click="showDetailDialog('timerProduct')"></btn>
                        <btn :type="0" :width="88" info="取消发布" @click="openConfirm('TimerStop')" v-if="isSelf"></btn>
                        <btn :type="0" :width="88" info="立即发布" @click="openConfirm('TimerPub')" v-if="isSelf"></btn>
                    </div>
                </div>
            </el-col>
            <el-col class="item">
                <el-row class="title-ver" type="flex" justify="center" align="middle">
                    <div class="split"></div>
                    <span>线上版本</span>
                    <div class="split"></div>
                </el-row>
                <div class="detail prod" style="padding-bottom:0">
                    <div class="prod-channel-container">
                        <label>渠道</label>
                        <el-select
                            v-model="prodChannel"
                            @change="prodChannelChange"
                            size="mini"
                            placeholder="请选择"
                            style="width:150px"
                        >
                            <el-option
                                v-for="item in channelList"
                                :key="item.channelKey"
                                :label="item.channelName"
                                :value="item.channelKey"
                            >
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div v-if="product">
                    <div class="detail prod" style="padding-top:0">
                        <div><label>版本号</label><span class="highlight">{{product.version}}</span></div>
                        <div><label>发布者</label><span>{{product.nickName}}</span></div>
                        <div><label>发布时间</label><span>{{formatDate(product.publishTime)}}</span></div>
                        <div><label>描述</label><span class="desc">{{product.description}}</span></div>
                    </div>
                    <div class="op-btns">
                        <btn :type="gray && gray.status !== 72 ? 3 : 1" :width="88" info="版本回退" @click="showfirstDialog('product')" v-if="isSelf"></btn>
                        <btn :type="gray && gray.status !== 72 ? 3 : 2" :width="88" info="暂停服务" @click="stopService" v-if="isSelf && suspendStatus === 0 "></btn>
                        <btn :type="gray && gray.status !== 72 ? 3 : 1" :width="88" info="恢复服务" @click="stopService" v-if="isSelf && suspendStatus === 1 "></btn>
                        <btn :type="1" :width="88" info="详情" @click="showDetailDialog('product')"></btn>
                    </div>
                </div>
                <div class="empty" v-else>暂无线上版本</div>
            </el-col>
        </el-row>
        <confirm :visible.sync="ConfirmVisible" @closeConfirm="closeConfirm">
            <h4 class="top-title" slot="top-title" v-if="dialogInfo[type].topTitle">{{dialogInfo[type].topTitle}}</h4>
            <h4 class="title-dia" slot="title" v-if="dialogInfo[type].title">{{dialogInfo[type].title}}</h4>
            <div class="gray-pub-content" v-if="type === 'GrayPub'">
                <p>确认后，将自动进行灰度发布。</p>
                <p>按设备比例灰度，3小时后自动转全量</p>
            </div>
            <p v-if="type !== 'GrayPub' && dialogInfo[type].content">{{dialogInfo[type].content}}</p>
            <div v-if="dialogInfo[type].select" slot="select" class="select">
                <div class="select-title">请确认全量发布方式</div>
                <div class="select-item">
                    <label class="service-label">{{dialogInfo[type].selectInfo.title}}</label>
                    <el-select v-model="fullPubInfo.type" size="mini" style="display: inline-block;width: 179px;" @change="changePub">
                        <el-option v-for="(value, key) in dialogInfo[type].selectInfo.selects" :key="key" :label="value.label" :value="parseInt(key, 10)"></el-option>
                    </el-select>
                </div>
                <div class="select-item" v-show="showNextSelect">
                    <label class="service-label">{{dialogInfo[type].nextSelect}}</label>
                    <el-date-picker
                        v-model="fullPubInfo.realTime"
                        type="datetime"
                        placeholder="选择定时发布日期时间"
                        format="yyyy-MM-dd HH:mm"
                        size="mini"
                        :clearable="false"
                        :editable="false"
                        :picker-options="pickDate"
                        style="display: inline-block;width: 179px;"
                        @change="checkTime"
                        popper-class="time-select-popper"
                        >
                    </el-date-picker>
                    <div v-if="errorInfo" class="error-info">{{errorInfo}}</div>
                </div>
            </div>
            <div v-if="type === 'channelChoose'">
                选择渠道
                <el-select
                    v-model="toAduitChannel"
                    @change="toAduitChannelChange"
                    multiple
                    size="small"
                    style="margin-left: 20px;"
                    placeholder="请选择">
                    <el-option
                        v-for="item in channelList"
                        :key="item.channelKey"
                        :label="item.channelName"
                        :value="item.channelKey"
                    >
                    </el-option>
                </el-select>
                <div v-if="errorInfo" class="channel-error-info">{{errorInfo}}</div>
            </div>
            <span slot="op-btns" class="op-btns">
                <btn v-for="(item, index) in dialogInfo[type].btns" :key="index" :type="item.type" :info="item.label" @click="item.clickEvent(item)" :showLoading="item.showLoading"></btn>
            </span>
        </confirm>
        <el-dialog :visible.sync="detailIsVisible" width="438px" custom-class="detail-dialog">
            <dev-basic-detail-popper class="content" :info="info" :type="detailType" :appInfo="appInfo"></dev-basic-detail-popper>
        </el-dialog>
        <el-dialog :visible.sync="versionRollbackVisible" width="340px" custom-class="detail-dialog" v-if="versionRollbackVisible" @close="close">
            <div slot="title" class="title-dialog">小程序版本回退</div>
            <product-pre-version-popper class="content" :info="preProductDetail" :preCodeUrl="preCodeUrl" :firstStepVisible="firstStepVisible" :only="onlyOneVersion" :secondStepVisible="secondStepVisible"></product-pre-version-popper>
            <div slot="footer" class="op-dialog">
                <btn :type="1" info="取消" @click="close" v-if="!onlyOneVersion"></btn>
                <btn :type="1" info="知道了" @click="close" v-if="onlyOneVersion"></btn>
                <btn :type="0" info="下一步" @click="nextStep" v-if="firstStepVisible && !onlyOneVersion "></btn>
                <btn :type="0" info="确认回退" @click="confirmRollback" v-if="secondStepVisible"></btn>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import Btn from '@/components/Button.vue';
import Confirm from '@/components/Confirm.vue';
import DevBasicDetailPopper from '@/components/DevBasicDetailPopper';
import ProductPreVersionPopper from '@/components/ProductPreVersionPopper';

import dao from '@/lib/dao';
import formatDate from '@/lib/formatDate';
import QRCode from 'qrcode';

const statusMap = { // 审核版本状态 0开发版 1审核中 2审核失败 3审核成功 4已发布 5被覆盖
    1: '审核中',
    2: '已驳回',
    3: '审核通过',
    tip: {
        1: '审核中',
        2: '被驳回',
        3: '审核通过'
    },
    time: {
        81: '待发布',
        83: '已取消'
    }
};

export default {
    props: {
        appInfo: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    computed: {
        isSelf() {
            return this.appInfo.origin == 0;
        },
        versionRollbackVisible: {
            get: function() {
                if (this.firstStepVisible ) {
                    return this.firstStepVisible
                } else if (this.secondStepVisible) {
                    return this.secondStepVisible
                }
            },
            // 改变visible值时，没有set方法会报错
            set:function() {

            }
        },
        prefix: {
            get: function() {
                if (this.preProductDetail) {
                    return 'precheck'
                }
            },
            // 改变visible值时，没有set方法会报错
            set:function() {

            }
        },
        isMultiChannel: {
            get: function() {
                return this.channelList.length >= 2;
            },
            // 改变visible值时，没有set方法会报错
            set:function() {

            }
        },
        onlyOneVersion: {
            get: function () {
                const self = this
                const preProductDetail = ((this.allChannelData.lastProduct || []).find(function(item) {return item.channelUuid === self.prodChannel}))
                if (preProductDetail) {
                    this.preProductDetail = preProductDetail
                    this.getPreQrcode();
                }
                return !preProductDetail
            },
            set:function() {

            }
        }
    },
    components: {
        Btn,
        Confirm,
        DevBasicDetailPopper,
        ProductPreVersionPopper
    },
    data() {
        const self = this;
        return {
            fullPubInfo: {
                type: 0,
                realTime: formatDate(new Date(), 'yyyy-MM-dd HH:mm')
            },
            showNextSelect: false,
            pickDate: {
                disabledDate(time) {
                    const dateTime = new Date(new Date().toLocaleDateString());
                    const tomorrow = new Date(new Date().setHours(12, 0, 0, 0)).getTime() - 86400000
                    return (time.getTime() < tomorrow) || (time.getTime() > Date.now() + 86400000 * 6);
                }
            },
            appId: '',
            allChannelData: {},
            channelList: [],
            channelNameMap: {},
            toAduitChannel: [],
            prodChannel: '',
            check: null,
            development: null,
            gray: null,
            product: null,
            timerProduct: null,
            statusMap,
            ConfirmVisible: false,
            type: 'Devdel',
            detailType: '',
            codeUrl: '',
            codeType:0, // 0: 展示原框架二维码, 1: 展示新框架二维码
            detailIsVisible: false,
            isProduct: false,
            info: {},
            selectMap: [{value: 0, label: '立即发布'}, {value: 1, label: '按时发布'}],
            defaultValue: 0,
            dialogInfo: {
                'Devdel': {
                    title: '是否删除当前开发版本?',
                    content: '删除后开发者需要重新上传',
                    btns: [
                        {
                            label: '取消',
                            type: 1,
                            clickEvent() {
                                self.closeConfirm(); 
                            }
                        },
                        {
                            label: '删除',
                            type: 0,
                            clickEvent() {
                                self.deleteDev();
                            }
                        }
                    ]
                },
                'channelChoose': {
                    topTitle: '选择发布渠道',
                    // title: '是否提交审核当前开发版本?',
                    // content: `当前已有审核中版本，提交后将覆盖原有版本`,
                    btns: [
                        {
                            label: '取消',
                            type: 1,
                            clickEvent() {
                                self.closeConfirm();
                            }
                        },
                        {
                            label: '继续提交',
                            type: 0,
                            clickEvent() {
                                if (!self.toAduitChannel.length) {
                                    self.errorInfo = '请选择渠道'
                                    return
                                }
                                if (self.check) { // 存在审核版本
                                    self.openConfirm('replaceAudit');
                                } else { // 提交
                                    self.submitDev();
                                }
                            }
                        }
                    ]
                },
                'replaceAudit': {
                    title: '是否提交审核当前开发版本?',
                    content: `当前已有审核中版本，提交后将覆盖原有版本`,
                    btns: [
                        {
                            label: '取消',
                            type: 1,
                            clickEvent() {
                                self.closeConfirm();
                            }
                        },
                        {
                            label: '继续提交',
                            type: 0,
                            clickEvent() {
                                self.submitDev();
                            }
                        }
                    ]
                },
                'AuditPub': {
                    title: '是否提交发布?',
                    content: '确认后，将自动进行灰度发布',
                    btns: [
                        {
                            label: '取消',
                            type: 1,
                            clickEvent() {
                                self.closeConfirm();
                            }
                        },
                        {
                            label: '确认',
                            type: 0,
                            clickEvent(item) {
                                self.publish(item);
                            }
                        }
                    ]
                },
                'GrayStop': {
                    title: '是否停止当前版本 灰度发布?',
                    content: '停止灰度发布，将自动切回灰度前的线上正式版本',
                    btns: [
                        {
                            label: '取消',
                            type: 1,
                            clickEvent() {
                                self.closeConfirm();
                            }
                        },
                        {
                            label: '停止灰度',
                            type: 0,
                            clickEvent(item) {
                                self.stopGray(item);
                            }
                        }
                    ]
                },
                'GrayCheckSubmit': {
                    title: '是否提交审核 立即全量发布?',
                    content: '审核通过后，将自动全量发布',
                    btns: [
                        {
                            label: '取消',
                            type: 1,
                            clickEvent() {
                                self.closeConfirm();
                            }
                        },
                        {
                            label: '提交审核',
                            type: 0,
                            clickEvent() {
                                self.submitGrayCheck();
                            }
                        }
                    ]
                },
                'GrayCheckRecall': {
                    title: '是否撤销全量发布审核 申请？',
                    content: '确认取消后，将自动取消申请',
                    btns: [
                        {
                            label: '取消',
                            type: 1,
                            clickEvent() {
                                self.closeConfirm();
                            }
                        },
                        {
                            label: '确认取消申请',
                            type: 0,
                            clickEvent() {
                                self.recallGrayCheck();
                            }
                        }
                    ]
                },
                'AuditPubInGray': {
                    title: '当前存在灰度版本，请等待灰度完成或停止灰度后再进行操作',
                    btns: [{
                        label: '知道啦',
                        type: 0,
                        clickEvent() {
                            self.closeConfirm()
                        }
                    }]
                },
                'GrayPubPrompt': {
                    title: '提示',
                    content: '',
                    btns: [{
                        label: '知道啦',
                        type: 0,
                        clickEvent() {
                            self.closeConfirm();
                            self.dialogInfo['GrayPubPrompt'].content = '';
                        }
                    }]
                },
                'Rollback': {
                    title: '确定进行小程序版本回退吗?',
                    content: '',
                    btns: [
                        {
                            label: '取消',
                            type: 1,
                            clickEvent() {
                                self.closeConfirm();
                                self.secondStepVisible = false;
                            }
                        },
                        {
                            label: '确定',
                            type: 0,
                            clickEvent() {
                                self.rollback();
                                self.closeConfirm();
                                self.secondStepVisible = false;
                            }
                        }
                    ]
                },
                'GrayToProduct': {
                    title: '是否确认立即发布当前灰度版本?',
                    content: '',
                    btns: [
                        {
                            label: '取消',
                            type: 1,
                            clickEvent() {
                                self.closeConfirm();
                            }
                        },
                        {
                            label: '确定',
                            type: 0,
                            clickEvent() {
                                self.closeConfirm();
                                self.grayToProduct();
                            }
                        }
                    ]
                },
                'GrayPub': {
                    title: '是否确认灰度发布?',
                    content: '确认后，将自动进行灰度发布',
                    btns: [
                        {
                            label: '取消',
                            type: 1,
                            clickEvent() {
                                self.closeConfirm();
                            }
                        },
                        {
                            label: '确定',
                            type: 0,
                            clickEvent(item) {
                                self.grayPubing(item);
                            }
                        }
                    ]
                },
                'FullPub': {
                    title: '是否确认全量发布',
                    content: '',
                    select: true,
                    selectInfo: {
                        title: '发布时间',
                        selects: [{
                            value: 0,
                            label: '立即发布'
                        },{
                            value: 1,
                            label: '定时发布'
                        }]
                    },
                    nextSelect: '定时发布',
                    btns: [
                        {
                            label: '取消',
                            type: 1,
                            clickEvent() {
                                self.closeConfirm();
                            }
                        },
                        {
                            label: '确认发布',
                            type: 0,
                            clickEvent() {
                                self.fullRelease();
                            }
                        }
                    ]
                },
                'TimerStop': {
                    title: '是否确认取消定时发布?',
                    content: '',
                    btns: [
                        {
                            label: '取消',
                            type: 1,
                            clickEvent() {
                                self.closeConfirm();
                            }
                        },
                        {
                            label: '确定',
                            type: 0,
                            clickEvent() {
                                self.cancelTimerPub();
                            }
                        }
                    ]

                },
                'TimerPub': {
                    title: '是否确认立即发布?',
                    content: '',
                    btns: [
                        {
                            label: '取消',
                            type: 1,
                            clickEvent() {
                                self.closeConfirm();
                            }
                        },
                        {
                            label: '确定',
                            type: 0,
                            clickEvent() {
                                self.closeConfirm();
                                self.timerPublish();
                            }
                        }
                    ]
                }
            },
            fullPubType: 0,
            firstStepVisible: false,
            secondStepVisible: false,
            preProductDetail: {},
            preCodeUrl: '',
            showLoading: false,
            errorInfo: '',
            suspendStatus: ''
        };
    },
    methods: {
        getChannel() {
            dao.shop.getChannel({
                miniappId: this.appId,
                miniappType: 1
            }).then(data => {
                this.channelList = data.channelEnumModels;
                this.channelList.map(item => {
                    this.channelNameMap[item.channelKey] = item.channelName;
                });
            }).catch(msg => this.$message.error(msg));
        },
        getInfos() {
            dao.shop.getAllChannelStorage({ appId: this.appId }).then(data => {
                this.allChannelData = data || {}
                Object.keys(data || {}).forEach(key => {
                    this[key] = (data[key] || [])[0];
                    if (Object.keys(this[key] || {}).length === 0) {
                        this[key] = null;
                    } else {
                        if(key === 'product') {
                            this[key].channelInfo = this.channelNameMap[data[key][0].channelUuid]
                        } else {
                            this[key].channelInfo = data[key].map(item => item.channelUuid).map(key => this.channelNameMap[key]).join('、')
                        }                    
                    }
                });
                if (this.product) {
                    this.prodChannel = this.product.channelUuid
                    this.getSuspendInfo()
                }
                if (this.check) {
                    this.dialogInfo.replaceAudit.content = `提交后将覆盖当前已有的${this.statusMap.tip[this.check.status]}版本`;
                }
                if (this.development) {
                    this.getQrcode();
                }
            }).catch(msg => this.$message.error(msg));
        },
        getSuspendInfo() {
            dao.shop.getChannelBindInfo({
                channelUuid: this.prodChannel,
                appId: this.appId
            }).then(data => {
                this.suspendStatus = data.miniAppStatus
            }).catch(msg => this.$message.error(msg));
        },
        prodChannelChange(value) {
            dao.shop.getStorage({ appId: this.appId, channelKey: value }).then(data => {
                this.product = data.product;
                if (this.product) {
                    this.product.channelInfo = this.channelNameMap[this.product.channelUuid]
                    this.getSuspendInfo()
                }
            }).catch(msg => this.$message.error(msg));
        },
        toAduitChannelChange(value) {
            if(!value.length){
                this.errorInfo = '请选择渠道'
            }else {
                this.errorInfo = ''
            }
        },
        formatDate(str) {
            return formatDate(new Date(str), 'yyyy-MM-dd HH:mm');
        },
        closeConfirm() {
            this.errorInfo = '';
            this.fullPubInfo.type = 0;
            this.fullPubType = 0;
            this.showNextSelect = false;
            this.ConfirmVisible = false;
            this.toAduitChannel = [];
        },
        openConfirm(type) {
            if (type === 'AuditPub' && !this.product) {
                this.dialogInfo.AuditPub.content = '';
            }
            this.ConfirmVisible = true;
            this.type = type;
            console.log('this.showNextSelect', this.showNextSelect)
        },
        deleteDev() {
            dao.shop.deletDevVer({
                appId: this.appId,
                storageId: this.development.storageId
            }).then(data => {
                this.closeConfirm();
                this.getInfos();
            }).catch(msg => this.$message.error(msg));
        },
        deleteAuditReject() {
            dao.shop.deleteAudVer({
                appId: this.appId,
                storageId: this.check.storageId
            }).then(data => {
                this.getInfos();
            }).catch(msg => this.$message.error(msg));
        },
        submitDevJudge() {
            if (this.gray && this.gray.status !== 72) { // 存在灰度版本
                return;
            }
            // 有多个渠道时弹出渠道选择框，否则保持原交互逻辑
            if (this.isMultiChannel) {
                this.openConfirm('channelChoose');
            } else {
                // 单个渠道时不出现渠道选择框，设置渠道默认值
                this.toAduitChannel = [(this.channelList[0] || {}).channelKey]
                if (this.check) { // 存在审核版本
                    this.openConfirm('replaceAudit');
                } else { // 提交
                    this.submitDev();
                }
            }
        },
        submitDev() {
            dao.shop.devVerSubmit({
                appId: this.appId,
                storageId: this.development.storageId,
                channelKeys: this.toAduitChannel
            }).then(data => {
                this.closeConfirm();
                this.getInfos();
            }).catch(msg => this.$message.error(msg));
        },
        grayPubing(item) {
            console.log('grayPubing')
             // 灰度发布时检查渠道是否有线上版本，没有线上版本时提示用户先对无线上版本的渠道单独先进行发布
             // 在已选择的渠道中找没有线上版本的渠道
            const checkedChannels = (this.allChannelData.check || []).map(item => item.channelUuid).filter((key) => (this.allChannelData.product || []).findIndex((item) => key === item.channelUuid) === -1);
            if ( checkedChannels.length ) {
                const checkedChannelName = checkedChannels.map(key => this.channelNameMap[key]).join('、')
                this.dialogInfo['GrayPubPrompt'].content = `当前版本的渠道中，${checkedChannelName}没有线上版本，无法进行灰度发布，请对${checkedChannelName}渠道进行全量发布`
                this.openConfirm('GrayPubPrompt');
                return
            }
            item.label = '发布中';
            dao.shop.publish({
                appId: this.appId,
                storageId: this.check.storageId
            }).then(data => {
                this.$message.success('灰度发布成功');
                this.closeConfirm();
                this.getInfos();
            }).catch(msg => {
                this.$message.error(msg);
            }).finally(() => {
                item.label = '灰度发布';
                item.showLoading = false;
            });
        },
        grayToProduct() {
            console.log('立即发布--gray')
            dao.shop.grayToProduct({ // 灰度立即发布
                appId: this.appId,
                storageId: this.gray.storageId,
                version: this.gray.version
            }).then(data => {
                this.$message.success('发布成功');
                this.closeConfirm();
                this.getInfos();
            }).catch(msg => {
                this.$message.error(msg);
            });
        },
        fullRelease() { // 全量发布
            if (this.errorInfo) {
                return;
            }
            console.log('this.fullRelease', formatDate(new Date(), 'yyyy-MM-dd HH:mm:00'), this.fullPubType)
            if (this.fullPubType === 0) {
                console.log('1')
                dao.shop.fullPublish({ // 立即发布
                    appId: this.appId,
                    storageId: this.check.storageId,
                    version: this.check.version
                }).then(data => {
                    this.$message.success('立即发布成功');
                    this.closeConfirm();
                    this.getInfos();
                }).catch(msg => {
                    this.$message.error(msg);
                });
            }
            if (this.fullPubType === 1) {
                const time = formatDate(new Date(this.fullPubInfo.realTime), 'yyyy-MM-dd HH:mm:00');
               
                dao.shop.timerPublish({ // 定时发布
                    appId: this.appId,
                    storageId: this.check.storageId,
                    publishTime: time,
                    version: this.check.version
                }).then(data => {
                    this.$message.success('定时发布成功');
                    this.closeConfirm();
                    this.getInfos();
                }).catch(msg => {
                    this.$message.error(msg);
                });
            }
        },
        cancelTimerPub() {
            dao.shop.cancelTimerPub({ // 定时发布
                appId: this.appId,
                storageId: this.timerProduct.storageId,
                version: this.timerProduct.version
            }).then(data => {
                this.$message.success('已取消定时发布');
                this.closeConfirm();
                this.getInfos();
            }).catch(msg => {
                this.$message.error(msg);
            });
        },
        timerPublish() {
            // 定时发布--立即发布
            dao.shop.immediatePublish({
                appId: this.appId,
                storageId: this.timerProduct.storageId,
                version: this.timerProduct.version
            }).then(data => {
                this.$message.success('立即发布成功');
                this.closeConfirm();
                this.getInfos();
            }).catch(msg => {
                this.$message.error(msg);
            });
        },
        changePub(val) {
            console.log('changePub', val)
            this.fullPubType = val;
            if (val) {
                this.showNextSelect = true;
                this.fullPubInfo.realTime = formatDate(new Date(), 'yyyy-MM-dd HH:mm');
                console.log('changeP------', this.fullPubInfo.realTime)
            }
            else {
                this.showNextSelect = false;
                this.fullPubInfo.realTime = '';
            }
        },
        checkTime(val) {
            console.log('选择的时间',new Date(val).getTime(), new Date().getTime(), this.fullPubInfo.realTime)
            if (new Date(val).getTime() < new Date().getTime()) {
                this.errorInfo = '定时发布时间不可早于当前时间';
            } else {
                this.errorInfo = '';
            }
        },
        submitPublish() {
            if (this.gray && this.gray.status !== 72) {
                return;
            }
            this.openConfirm('AuditPub');
        },
        publish(item) {
            item.label = '发布中';
            dao.shop.fullPublish({
                appId: this.appId,
                storageId: this.check.storageId,
                version: this.check.version
            }).then(data => {
                this.$message.success('发布成功');
                this.closeConfirm();
                this.getInfos();
            }).catch(msg => {
                this.$message.error(msg);
            }).finally(() => {
                item.label = '提交发布';
                item.showLoading = false;
            });
        },
        stopGray(item) {
            item.label = '停止中';
            this.$set(item, 'showLoading', true);
            dao.shop.stopGray({
                appId: this.appId,
                storageId: this.gray.storageId
            }).then(() => {
                this.$message.success('操作成功')
                this.closeConfirm();
                this.getInfos();
            }).catch(msg => {
                this.$message.error(msg)
            }).finally(() => {
                item.label = '停止灰度';
                item.showLoading = false;
            });
        },
        submitGrayCheck() {
            dao.shop.submitGrayCheck({
                appId: this.appId,
                storageId: this.gray.storageId
            }).then(() => {
                this.$message.success('操作成功')
                this.closeConfirm();
                this.getInfos();
            }).catch(msg => {
                this.$message.error(msg)
            });
        },
        recallGrayCheck() {
            dao.shop.recallGrayCheck({
                appId: this.appId,
                storageId: this.gray.storageId
            }).then(() => {
                this.$message.success('操作成功')
                this.closeConfirm();
                this.getInfos();
            }).catch(msg => {
                this.$message.error(msg)
            });
        },
        getQrcode() {
            let type = this.appInfo.type == 0 ? 'applet' : 'game';
            QRCode.toDataURL(`https://miniapp.bilibili.com/${type}/predev-${this.appId}?_biliFrom=testdev`)
            .then(url => {
                this.codeUrl = url;
            })
            .catch(err => {
                console.error(err)
            })
        },
        getPreQrcode() {
            let type = this.appInfo.type == 1 ? 'game' : 'applet';
            QRCode.toDataURL(`https://miniapp.bilibili.com/${type}/${this.appId}?_biliFrom=testdev&_biliStorageId=${this.preProductDetail.storageId}`)
                .then(url => {
                    this.preCodeUrl = url;
                })
                .catch(err => {
                    console.error(err)
                })
        },
        getNewQrcode(){
            if(this.codeType == 0){
                let type = this.appInfo.type == 0 ? 'appletx' : 'game';
                QRCode.toDataURL(`https://miniapp.bilibili.com/${type}/predev-${this.appId}?_biliFrom=testdev`)
                .then(url => {
                    this.codeUrl = url;
                    this.codeType = 1
                })
                .catch(err => {
                    console.error(err)
                })
            }else{
                try {
                     this.getQrcode()
                     this.codeType = 0
                } catch (error) {
                     console.error(err)
                }
               
            }
           
        },
        showDetailDialog(type) {
            this.detailType = type;
            this.info = this[type];
            this.detailIsVisible = true;
        },
        showfirstDialog(type) {
            if (this.gray && this.gray.status !== 72) {
                this.openConfirm('AuditPubInGray');
                return;
            }
            if(this.product.status === 4 || this.product.status === 42 || this.product.status === 82) {
                this.secondStepVisible = false;
                this.firstStepVisible = true;
            } else if (this.product.status === 6) {
                this.$message.error('不可再次回退');
            }
            console.log('deidei', type)
        },
        nextStep() {
            this.firstStepVisible = false;
            this.secondStepVisible = true;
        },
        confirmRollback() {
            this.openConfirm('Rollback');
        },
        rollback() {
            dao.shop.rollbackProductVersion({
                appId: this.appId,
                storageId: this.preProductDetail.storageId, // 传目标storageId
                channelKeys: [this.prodChannel]
            }).then(_=> {
                this.$message.success('版本回退成功')
                this.close();
                this.getInfos();
            })
            .catch(msg => {
                if(msg.code === 83001005) {
                    this.$message.error('你没有操作权限，请联系管理员。');
                } else {
                    this.$message.error(msg);
                }
            });
        },
        close(){
            this.firstStepVisible = false;
            this.secondStepVisible = false;
        },
        stopService() {
            if (this.gray && this.gray.status !== 72) {
                this.openConfirm('AuditPubInGray');
                return;
            }
           window.location.href =  window.location.href.replace('devmng', 'setting');
        }
    },
    mounted() {
        this.appId = this.$route.params.appId;
        // TODO
        this.getChannel();
        this.getInfos();
    }
}
</script>
<style lang="less" scoped>
.m-dev-manage {
    word-break: break-all;
    .title {
        position: relative;
        margin: 0;
        color: #5C667E;
        margin-bottom: 15px;
        font-weight: normal;
        .icon-detail {
            display: inline-block;
            position: absolute;
            top: 3px;
            width: 16px;
            height: 16px;
            margin-left: 9px;
            background: url(../../assets/icon_attention@2x.png) no-repeat center/contain;
            cursor: pointer;
        }
    }
    .content {
        font-size: 12px;
        flex-wrap: wrap;
        margin-right: -20px;
        .item {
            border: 1px solid #E0E5EC;
            min-height: 318px;
            position: relative;
            padding-bottom: 52px;
            background-color: #FFF;
            margin-right: 20px;
            margin-bottom: 20px;
            width: 325px;
            .title-ver {
                font-size: 16px;
                color: #222;
                height: 70px;
                font-weight: bold;
                .split {
                    width: 18px;
                    height: 1px;
                    background-color: #9AA7C1;
                    & + span {
                        margin: 0 7px;
                    }
                }
                .status {
                    font-size: 14px;
                    margin-left: -7px; 
                    &.toAudit {
                        color: #F7B32C;
                    }
                    &.success {
                        color: #43CE5B;
                    }
                    &.fail {
                        color: #FF7B58;
                    }
                }
            }
            .empty {
                position: absolute;
                left: 0;
                right: 0;
                top: ~'calc((100% - 18px - 17px) / 2)';
                bottom: 0;
                color: #9AA7C1;
                text-align: center;
            }
            .detail {
                padding: 5px 35px 58px;
                color: #5C667E;
                > div {
                    margin-bottom: 12px;
                    padding-left: 80px;
                    position: relative;
                    min-height: 17px;
                    line-height: 17px;
                    label {
                        position: absolute;
                        left: 0;
                        display: inline-block;
                        width: 72px;
                        text-align: right;
                    }
                    .highlight {
                        font-family: PingFangSC-Medium;
                        font-size: 14px;
                        color: #5C667E;
                    }
                    .code {
                        display: inline-block;
                        position: relative;
                    }
                }
                .reject-info {
                    padding-left: 0;
                    color: #FF7B58;
                    background-color: rgba(255, 123, 88, 0.1);
                    border-radius: 2px;
                    padding: 6px;
                    word-break: break-all;
                }
            }
            .op-btns {
                position: absolute;
                left: 0;
                right: 0;
                bottom: 52px;
                text-align: center;
                .add {
                    margin-right: 8px;
                    &:last-child {
                        margin-right: 0;
                    }
                }
            }
        }
    }
    .detail-dialog {
        .content {
            border: none;
            margin: -30px -20px;
            padding: 5px 25px 18px;   
        }
        .title-dialog {
            color: #5C667E;
        }
        .op-dialog {
            text-align: center;
            .add {
                margin-right: 10px;
                
                &:last-child {
                    margin-right: 0;
                }
            }
        }
    }
    .select {
        .select-title {
            margin-left: 42px;
            margin-bottom: 20px;
        }
        .select-item {
            font-size: 12px;
            text-align: center;
            margin-bottom: 5px;

            &:last-child {
                margin-bottom: 0;
            }
            .service-label {
                display: inline-block;
                margin-right: 10px;
                margin-bottom: 20px;
            }
            .error-info {
                font-size: 10px;
                color: #FF7B58;
                margin-left: 46px;
            }
        }
    }
    .channel-error-info {
        font-size: 10px;
        color: #FF7B58;
        margin:5px 30px 0 0;
    }
}
.el-popover {
    .content {
        font-size: 12px;
        line-height: 18px;
        padding: 4px 8px 8px;
        color: #5C667E;
        border: none;
        .sub-title {
            margin: 0;
        }
    }
    &.title-tips {
        p {
            color: #9AA7C1;
        }
    }
}

.time-select-popper {
    color: red;
    .el-picker-panel__footer {
        background: #f0f0f9;
    }
}

.prod-channel-container {
    display: flex;
    align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/page/manage/Dev.vue